<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Chuyên cần" :link="[{ text: 'Chuyên cần', href: '../diligence' }]" />
      </div>
    </div>
    <v-tabs class="mx-md-4" v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab v-for="item in getTabs" :key="item" class="tab-default">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-card outlined class="mx-md-4 elevation-0">
      <v-tabs-items v-model="tab" v-if="getTabs.length > 0">
        <v-tab-item v-if="getTabs.includes('Theo ngày')" :key="0">
          <DiligencesReport />
        </v-tab-item>
        <v-tab-item v-if="getTabs.includes('Theo lớp')" :key="1">
          <DiligenceClassReport />
        </v-tab-item>
        <v-tab-item v-if="getTabs.includes('Biểu đồ')" :key="2">
          <DiligenceAbsentChart />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import DiligencesReport from '../diligence/DiligencesReport.vue'
import DiligenceClassReport from '../diligence/DiligenceClassReport.vue'
import DiligenceAbsentChart from '../diligence/DiligenceAbsentChart.vue'

export default {
  components: {
    Breadcrumbs,
    DiligencesReport,
    DiligenceClassReport,
    DiligenceAbsentChart
  },
  data() {
    return {
      tab: 0
    }
  },
  computed: {
    getTabs() {
      const tabs = []
      if (this.$auth.policies['view-diligence-list']) {
        tabs.push('Theo ngày')
      }
      if (this.$auth.policies['view-diligence-list']) {
        tabs.push('Theo lớp')
      }
      if (this.$auth.policies['view-diligence-list']) {
        tabs.push('Biểu đồ')
      }
      return tabs
    }
  }
}
</script>
